var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-button {\n  background: url(" + escape(require("../images/btn_google_signin_normal.png")) + ") transparent 50% no-repeat;\n  width: 382px;\n  height: 92px;\n  margin: 4em auto; }\n\n.login-button:hover {\n  background: url(" + escape(require("../images/btn_google_signin_focus.png")) + ") transparent 50% no-repeat;\n  cursor: pointer; }\n\n.login-button:focus {\n  background: url(" + escape(require("../images/btn_google_signin_focus.png")) + ") transparent 50% no-repeat; }\n\n.login-button:active {\n  background: url(" + escape(require("../images/btn_google_signin_pressed.png")) + ") transparent 50% no-repeat; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/client/styles/GoogleLoginButton.css
// module id = 3240
// module chunks = 0